module.exports = __webpack_public_path__ + "static/media/privacy_get-all-results-you-want.199b411b.svg";